import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import WorkIcon from "@material-ui/icons/Work";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SkillSvg from "../../images/about-shape.svg";
import { scrollReveal } from "../../animation";
import { useScroll } from "./useScroll";
import { motion } from "framer-motion";
import Img from "react-cool-img";

const myPublications = [
  {
    image: "/images/header.png",
    title: "Resume",
    // dLink: "Resume",
    // descp: "Paper # IJRASET44822",
    // demoLink: "https://doi.org/10.22214/ijraset.2022.44822",
    websiteLink: "/Tejas_Sheth.pdf",
  },
];

const About = () => {
  const [tab, setTab] = useState("experience");
  const [element, controls] = useScroll();

  // const methodDoesNotExist = (aman) => {
  //   throw new Error("this is a sentry error");
  // };

  return (
    <motion.div id="about" className="about pb-6 pt-6">
      <img className="skills-img" src={SkillSvg} alt="" />

      <motion.div
        variants={window.innerWidth > 767 ? scrollReveal : null}
        ref={element}
        animate={controls}
        className="container"
      >
        <Row className="">
          <Col className="p-0 text-center" md={5}>
            {/* <img
              placeholder="/images/skills/lod.jpeg"
              src="/images/tejassheth.png"
              error="/images/skills/error.png"
              alt="Resume"
              onClick={methodDoesNotExist}
              height="50%"
            /> */}
          </Col>
          <Col className="" md={7}>
            <div className="about-info">
              <h1 className="pb-4">
                <span className="chonburi-font green-text ">Abo</span>ut Me
              </h1>
              <p className="details">
                <div>
                  As a Software Developer at the USC Institute for Creative
                  Technologies, I develop cutting-edge applications using Unity
                  3D and iOS app development, showcasing my ability to work
                  effectively in collaborative environments and deliver tangible
                  results. I have also contributed to multiple publications on
                  topics such as image recognition, SQL injection detection and
                  prevention, and reinforcement learning, demonstrating my
                  proficiency in data analysis and machine learning.
                  <br />
                  <br />I am currently pursuing a Master of Science degree in
                  Computer Science at the University of Southern California,
                  where I have acquired skills in data storage, image
                  recognition, and C#. I have also completed several online
                  courses and certifications in Python, Go, and other
                  programming languages, enhancing my technical knowledge and
                  versatility. With a keen eye on the latest developments in
                  space exploration, I bring a unique blend of technical acumen
                  and celestial curiosity. I am actively seeking opportunities
                  that allow me to apply my skills to projects at the
                  intersection of technology and space.
                </div>
                {/* <div>
                  ─ Final Year Student pursing Bachelor's of Engineering in
                  Computer Engineering from University of Mumbai.
                </div>
                <div>
                  ─ Well-versed in Python, Machine Learning, Web Scraping,
                  Javascript, ReactJS along with other domains.
                </div>
                <div>─ Passionate about Football, Cricket, Music.</div> */}
                {/* <div>─ </div> */}
                {/* Tech Intern at Mosaic Wellness Pvt. Ltd.
                My major strengths are in giving realistic promises, being responsive and responsible, concentrating on business needs and communications. Interested
                in devising a better problem‑solving method for challenging
                tasks. */}
              </p>
              <div
                // className="d-flex align-items-center resume-section "
                className="projects-cards"
                textAlign="center"
              >
                <Row className="justify-content-center">
                  {myPublications.map((About, index) => {
                    return (
                      <Col md={9} className="mb-1" key={index + 1}>
                        <div className="project-card">
                          <a href={About.websiteLink} target="_blank">
                            <div className="img-section">
                              <Img
                                placeholder="https://p4.wallpaperbetter.com/wallpaper/990/450/548/loading-wallpaper-preview.jpg"
                                src={About.image}
                                error="/images/download.png"
                                alt="Publications"
                                className="fixImageDynamic"
                              />

                              <div className="imageCardEffect"></div>
                            </div>
                          </a>
                          <div className="project-info1">
                            <a href={About.websiteLink} target="_blank">
                              <h5
                                className="color-white font-weight-bold"
                                align="center"
                              >
                                {About.title}
                              </h5>
                            </a>
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
                {/* <h5>Resume:</h5>{" "}
                <a
                  rel="noopener noreferrer"
                  href="/Resume - TejasSheth.pdf"
                  target="_blank"
                >
                  View
                </a> */}
              </div>
              <div id="experience" className="mt-5">
                <Row className="tabs mb-2">
                  <Col
                    className={`
                      ${
                        tab === "education"
                          ? "active-tab custom-mr-3"
                          : "inactive-tab"
                      } tab`}
                    onClick={() => setTab("education")}
                  >
                    <LocalLibraryIcon />
                    <h5>Education</h5>
                  </Col>
                  <Col
                    className={`
                      ${
                        tab === "experience"
                          ? "active-tab custom-ml-3"
                          : "inactive-tab"
                      } tab`}
                    onClick={() => setTab("experience")}
                  >
                    <WorkIcon />
                    <h5>Experience</h5>
                  </Col>
                  <Col
                    className={`
                      ${
                        tab === "volunteer"
                          ? "active-tab custom-mr-3"
                          : "inactive-tab"
                      } tab`}
                    onClick={() => setTab("volunteer")}
                  >
                    <SupervisorAccountIcon />
                    <h5>Volunteer</h5>
                  </Col>
                </Row>
                {/* <br /> */}
                <div className="about-sub-data">
                  {tab === "experience" ? (
                    <div className="work-experiences">
                      {/* <p style={{ display: "flex", flexDirection: "column" }}> */}

                      <h5 className="color-white font-weight-bold">
                        <a
                          rel="noreferrer"
                          href="https://github.com/TejasSheth104/CSCI526-SuperSonics"
                          className="color-white font-weight-bold"
                          target="_blank"
                        >
                          ‘Color Quest’ - Indie-Platformer Game
                        </a>
                        <h6 className="text-justify">Lead Game Programmer</h6>
                      </h5>
                      <h6 align="right">
                        <i>Jan 2024 - May 2024</i>
                      </h6>
                      {/* <h6 className="text-justify">Tech Intern</h6> */}
                      {/* </p> */}
                      <ul>
                        <li>
                          Spearheaded programming and analytics efforts for
                          'Color Quest,' an indie 2D platformer game inspired by
                          Super Mario Bros. with a unique color-changing twist -{" "}
                          <a href="https://tejassheth104.github.io/CSCI526-SuperSonics/gold-prototype-build/index.html">
                            Link
                          </a>
                          .
                        </li>
                        <li>
                          Developed key C# scripts using Unity 2D, including
                          mechanics for color-changing player and platforms,
                          super power timer countdown bar, jump mechanics, coin
                          and collectible collection, and collision detection
                          for spikes and moving objects, etc.
                        </li>
                        <li>
                          This role involved leading the technical development
                          of gameplay features within Unity 2D, ensuring smooth
                          mechanics and optimizing player experience through
                          analytics-driven enhancements.
                        </li>
                        <br />
                        <b>Technology Stack</b>: Unity Engine, Unity2D, C#, Git
                        and GitHub, Discord, Documentation.
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          rel="noreferrer"
                          href="https://ict.usc.edu/research/labs-groups/virtual-human-therapeutics-lab/"
                          className="color-white font-weight-bold"
                          target="_blank"
                        >
                          Virtual Human Therapeutics Lab, USC Institute for
                          Creative Technologies
                        </a>
                        <h6 className="text-justify">Software Developer</h6>
                      </h5>
                      <h6 align="right">
                        <i>Jan 2024 - Present</i>
                      </h6>
                      {/* <h6 className="text-justify">Tech Intern</h6> */}
                      {/* </p> */}
                      <ul>
                        <li>
                          Developed the BattleBuddy application using Unity 3D
                          for iOS app development, developing a custom C# script
                          for implementing long-press functionality and
                          drag-and-drop features for game objects.
                        </li>
                        <li>
                          Created a "Favorite Photo" module enabling users to
                          select and view favorite photos within the app.
                        </li>
                        <li>
                          Assisted in documentation review and enhancement,
                          engaged in interdisciplinary research on virtual
                          humans' impact on mental and emotional well-being.{" "}
                        </li>
                        <br />
                        <b>Technology Stack</b>: Unity Engine, Unity3D, C#,
                        Tortoise SVN, Jira, Slack, Documentation.
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          rel="noreferrer"
                          href="https://priceschool.usc.edu/"
                          className="color-white font-weight-bold"
                          target="_blank"
                        >
                          Urban Future’s Data Core, USC Sol Price School of
                          Public Policy
                        </a>
                        <h6 className="text-justify">
                          Software Engineer, Team Lead
                        </h6>
                      </h5>
                      <h6 align="right">
                        <i>Aug 2023 - Dec 2023</i>
                      </h6>
                      {/* <h6 className="text-justify">Tech Intern</h6> */}
                      {/* </p> */}
                      <ul>
                        <li>
                          Led a team of 6 in developing a Python web scraping
                          program to extract research data from Google Scholar
                          by professors, resulting in a comprehensive database
                          accessible to students and faculty.
                        </li>
                        <li>
                          Implemented agile software development methodologies
                          for efficient project management, overseeing data
                          analysis and visualization to provide actionable
                          insights for public policy and business strategies.
                        </li>
                        <br />
                        <b>Technology Stack</b>: Python, WebScraping, Selenium,
                        BeautifulSoup4, Database Systems, Google Scholar, Data
                        Analysis, Data Visualization
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          rel="noreferrer"
                          href="https://www.mosaicwellness.in/"
                          className="color-white font-weight-bold"
                          target="_blank"
                        >
                          Mosaic Wellness Pvt. Ltd.
                        </a>
                        <h6 className="text-justify">Tech Intern</h6>
                      </h5>
                      <h6 align="right">
                        <i>June 2022 - July 2022</i>
                      </h6>
                      {/* <h6 className="text-justify">Tech Intern</h6> */}
                      {/* </p> */}
                      <ul>
                        <li>
                          Built a frontend component library to standardize UI
                          elements, facilitating efficient code management and
                          progress tracking.
                        </li>
                        <li>
                          Expanded knowledge of the essential fundaments of
                          React.js, TypeScript required to develop an admin
                          panel enhancing internal coordination and streamlining
                          processes.
                        </li>
                        <br />
                        <b>Technology Stack</b>: ReactJS, Typescript, Storybook,
                        Javascript, Redux, Component Library.
                      </ul>
                      {/* <br /> */}
                      <h5 className="color-white font-weight-bold">
                        <a
                          href="https://nspglobalservices.in/"
                          className="color-white font-weight-bold"
                        >
                          NSP Ites Pvt. Ltd.
                        </a>
                        <h6 className="text-justify">
                          Machine Learning Intern
                        </h6>
                      </h5>
                      <h6 align="right">
                        <i>July 2021 - January 2022</i>
                      </h6>
                      <ul>
                        <li>
                          Developed Python web scraping tool to boost sales
                          effectiveness and meet client demands efficiently.
                        </li>
                        <li>
                          Prototyped WhatsApp Business automation system for
                          faster customer responses, enhancing client
                          satisfaction and streamlining communication.
                        </li>
                        <br />
                        <b>Technology</b>: Python, WebScraping, Selenium,
                        BeautifulSoup4, WhastApp Automation.
                      </ul>
                      {/* <br /> */}
                      <h5 className="color-white font-weight-bold">
                        <a
                          href="https://github.com/TejasSheth104/SQLinjection"
                          className="color-white font-weight-bold"
                        >
                          Detection of SQL Injection using Reinforcement
                          Learning
                        </a>
                        <h6 className="text-justify">
                          Team Lead Programmer & Researcher
                        </h6>
                      </h5>
                      <h6 align="right">
                        <i>Aug 2022 - May 2023</i>
                      </h6>
                      <ul>
                        <li>
                          Led a 4-person team in engineering a Reinforcement
                          Learning system using Q-Learning to mitigate SQL
                          Injection Attacks, resulting in enhanced security
                          measures and reducing cybersecurity risks.
                        </li>
                        <li>
                          Published and presented novel research at conferences
                          in University of Loughborough, London -{" "}
                          <a href="https://ieeexplore.ieee.org/document/10149965">
                            Link
                          </a>{" "}
                          and KJ Somaiya University (KJSIEIT), Mumbai -{" "}
                          <a href="https://ieeexplore.ieee.org/document/10039662">
                            Link
                          </a>
                          .
                        </li>
                        <br />
                        <b>Technology</b>: Python, Machine Learning,
                        Reinforcement Learning, WebApp, ReactJS, Research,
                        Documentation.
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          href="https://github.com/TejasSheth104/ReverseImageQuerying"
                          className="color-white font-weight-bold"
                        >
                          Reverse Image Querying
                        </a>
                        <h6 className="text-justify">
                          Lead Programmer & Researcher
                        </h6>
                      </h5>
                      <h6 align="right">
                        <i>Jan 2022 - May 2022</i>
                      </h6>
                      <ul>
                        <li>
                          Redesigned a solution using cosine similarity model to
                          extract similar images with 60%+ accuracy, enhancing
                          image recognition capabilities and facilitating
                          efficient image retrieval.
                        </li>
                        <li>
                          Published research in IJRASET Journal with 500+ views
                          -{" "}
                          <a href="https://doi.org/10.22214/ijraset.2022.44822">
                            Link
                          </a>
                          , contributing to the academic community.
                        </li>
                        <br />
                        <b>Technology</b>: Python, Machine Learning, Cosine
                        Similarity, WebApp, ReactJS, Research, Documentation.
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          href="https://github.com/TejasSheth104/Security-Camera"
                          className="color-white font-weight-bold"
                        >
                          Real-time Motion Detection System
                        </a>
                        <h6 className="text-justify">Lead Programmer</h6>
                      </h5>
                      <h6 align="right">
                        <i>Aug 2022 - Dec 2022</i>
                      </h6>
                      <ul>
                        <li>
                          Developed a real-time motion detection system using
                          Python and OpenCV to monitor and detect unusual
                          activities captured by a camera feed.
                        </li>
                        <li>
                          Implemented algorithms for motion detection and object
                          tracking, enabling the system to identify and track
                          moving objects within the camera's field of view.
                        </li>
                        <li>
                          Integrated an alert system to notify users upon
                          detecting motion, enhancing security monitoring
                          capabilities.
                        </li>
                        <br />
                        <b>Technology</b>: Python, Computer Vision, OpenCV,
                        Documentation.
                      </ul>

                      <h5 className="color-white font-weight-bold">
                        <a
                          href="\home"
                          className="color-white font-weight-bold"
                        >
                          Mentorship Program
                        </a>
                        <h6 className="text-justify">by APSIT SKILLS</h6>
                      </h5>
                      <h6 align="right">
                        <i>July 2021 - September 2021</i>
                      </h6>
                      <ul>
                        <li>Managed a group of 10-15 mentees.</li>
                        <li>
                          <b>Skills</b>: Communication, Management,
                          Organization.
                        </li>
                      </ul>
                      {/* <br /> */}
                      <h5 className="color-white font-weight-bold">
                        <a
                          href="\home"
                          className="color-white font-weight-bold"
                        >
                          Internship Program
                        </a>
                        <h6 className="text-justify">by APSIT SKILLS</h6>
                      </h5>
                      <h6 align="right">
                        <i>June 2020 - August 2020</i>
                      </h6>
                      <ul>
                        <li>Python Specialization Course from Coursera.</li>
                        <li>
                          <b>Technology</b>: Python.
                        </li>
                      </ul>
                    </div>
                  ) : null}

                  {tab === "education" ? (
                    <div className="education">
                      <div>
                        <h5 display="flex" flex-direction="row">
                          M.Sc. in Computer Science-{" "}
                          <b>
                            <i>G.P.A.: 3.6</i>
                          </b>
                          <h6 className="text-justify">
                            University of Southern California
                          </h6>
                        </h5>
                        <h6 align="right">
                          <i>Aug 2023 - Present</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            CSCI 570: Analysis of Algorithms
                          </li>
                          <li className="text-justify">
                            CSCI 585: Database Systems
                          </li>
                          <li className="text-justify">
                            CSCI 544: Natural Language Processing
                          </li>
                          <li className="text-justify">
                            CSCI 526: Advanced Mobile Devices and Games Consoles
                          </li>
                        </ul>
                        <h5 display="flex" flex-direction="row">
                          B.Engg. in Computer Engineering-{" "}
                          <b>
                            <i>C.G.P.A.: 9.21</i>
                          </b>
                          <h6 className="text-justify">University of Mumbai</h6>
                        </h5>
                        <h6 align="right">
                          <i>Aug 2019 - May 2023</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Subjects: Data Structures, Algorithms, DBMS,
                            Operating Systems, Computer Networks, Artificial
                            Intelligence etc.
                          </li>
                          <li className="text-justify">
                            Courses: Core Python, Cloud Computing and Full Stack
                            Development.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          H.S.C. Science-{" "}
                          <b>
                            <i>Percentage: 88.62</i>
                          </b>
                          <h6 className="text-justify">
                            Maharashtra State Board, People's Education Society
                            Trust High School & Jr. College, Thane East
                          </h6>
                        </h5>
                        <h6 align="right">
                          <i>Aug 2017 - May 2019</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            {/* I have studied basic Physics, Chemsitry, Maths and */}
                            C++, Assembly Language among other subjects.
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}

                  {tab === "volunteer" ? (
                    <div className="volunteer">
                      <div>
                        <h5 display="flex" flex-direction="row">
                          Smart City Club
                          <h6 className="text-justify">
                            Department of Computer Engineering, APSIT
                          </h6>
                        </h5>
                        <h6 align="right">
                          <i>July 2022-May 2023</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Volunteered at the events organized by the club.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Fundraising
                          <h6 className="text-justify">
                            Odisha Development Management Programme (ODMP){" "}
                          </h6>
                        </h5>
                        <h6 align="right">
                          <i>July 2022</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Communicating with the society for relief and
                            hygiene support and raising funds.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Anti Ragging Committee
                          <h6 className="text-justify">APSIT</h6>
                        </h5>
                        <h6 align="right">
                          <i>2021-Currently</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Communicating with the society for relief and
                            hygiene support and raising funds.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Grievance Redressal Committee
                          <h6 className="text-justify">APSIT</h6>
                        </h5>
                        <h6 align="right">
                          <i>2021-Currently</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Handled and settled grievances lodged by any student
                            by judging their merits.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Blood Donation Ambassador
                          <h6 className="text-justify">BloodConnect</h6>
                        </h5>
                        <h6 align="right">
                          <i>December 2021</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Aimed at eliminating the shortage of blood in the
                            country.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Safe City Safety Champion Campaign
                          <h6 className="text-justify">RedDotFoundation</h6>
                        </h5>
                        <h6 align="right">
                          <i>December 2021</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Aimed at making cities safer through the use of
                            crowd sourced data and technology.
                          </li>
                        </ul>
                        {/* <br /> */}
                        <h5 display="flex" flex-direction="row">
                          Volunteer
                          <h6 className="text-justify">APSIT Disha Portal</h6>
                        </h5>
                        <h6 align="right">
                          <i>May 2020</i>
                        </h6>
                        <ul>
                          <li className="text-justify">
                            Aimed at providing an Online Test environment with
                            practice tests for JEE and CET aspirants.
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </motion.div>
    </motion.div>
  );
};

export default About;
